"use client"
import { useState, useRef, useEffect } from "react";
import { deleteLog, deleteSubTaskLog, deleteTask } from "../api";


export default function DeleteModalForLogs({task,logId,setTasks,setTasks1,setTasks2,isSubtaskLog,setLogId}:any) {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);  // To track the deleting state
  const closeButtonLogRef = useRef<HTMLButtonElement | null>(null); // Ref for the close button

    // console.log(list)
  

  const handleDelete = async (): Promise<void> => {
    console.log(logId)
    setIsDeleting(true);
    let response
    try {
      if(isSubtaskLog){
        response = await deleteSubTaskLog(Number(logId))
      setTasks2((prevTasks2: any) => ({
        ...prevTasks2, // Preserve the other properties (total_logs, page, page_size)
        logs: prevTasks2.logs.filter((t: any) => t.logId !== logId), // Update the logs array
      }));
      }
      else{
        response = await deleteLog(logId)
        setTasks1((prevTasks1: any) => ({
          ...prevTasks1, // Preserve the other properties (total_logs, page, page_size)
          logs: prevTasks1.logs.filter((t: any) => t.logId !== logId), // Update the logs array
        }));

      }
          if (response) {
        // Use the ref to trigger the modal close
          setLogId(null)
        if (closeButtonLogRef.current) {
          closeButtonLogRef.current.click(); // Programmatically click the close button to dismiss the modal
        }
      } else {
        console.error("Failed to delete the list");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div
      className="edit-modal modal fade add-wallet-modal"
      id="exampleModal5"
      tabIndex={-1}
      aria-labelledby="exampleModal5Label"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Delete Log</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButtonLogRef} // Attach ref to the close button
            ></button>
          </div>
          <div className="modal-body">
            <h5 className="fw-normal mb-0">
            Are you sure you want to delete the log? <br />
            <strong>Note:</strong> This action is irreversible
            </h5>
            
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary px-3 py-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger ms-3 px-3 py-2"
              onClick={handleDelete}
              disabled={isDeleting}  // Disable the button while deleting
            >
              {isDeleting ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
